import Button from './Button'
import AlbumPreview from './AlbumPreview'
import Twitter from './Twitter'
import Instagram from './Instagram'
import TrailEffect from './TrailEffect'
import InfiniteText from './InfiniteText'
import SinglePost from './SinglePost'
import Bubbles from './Bubbles'
import Events from './Events'
import Contact from './Contact'

const blockList = [
  {
    name: 'button',
    Class: Button
  },
  {
    name: 'album-preview.link',
    Class: AlbumPreview
  },
  {
    name: 'twitter-feed',
    Class: Twitter
  },
  {
    name: 'instagram-feed',
    Class: Instagram
  },
  {
    name: 'image-trail-album',
    Class: TrailEffect
  },
  {
    name: 'infinite-text',
    Class: InfiniteText
  },
  {
    name: 'p-single-photos',
    Class: SinglePost
  },
  {
    name: 'bubbles',
    Class: Bubbles
  },
  {
    name: 'events__items',
    Class: Events
  },
  {
    name: 'contact',
    Class: Contact
  },
  {
    name: 'objects-lost',
    Class: Contact
  }
]

export default blockList



// WEBPACK FOOTER //
// ./scripts/blocks/blockList.js